import React from 'react';
import { motion } from 'framer-motion';
import { FaTimes, FaExclamationTriangle } from 'react-icons/fa';
import './GuideModal.css';

const WeChatTip = ({ onClose }) => {
  return (
    <motion.div
      className="guide-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <motion.div
        className="guide-modal wechat-tip"
        initial={{ scale: 0.9, opacity: 0, y: 20 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        exit={{ scale: 0.9, opacity: 0, y: 20 }}
        onClick={(e) => e.stopPropagation()}
      >
        <button className="close-btn" onClick={onClose}>
          <FaTimes />
        </button>

        <div className="warning-icon">
          <FaExclamationTriangle />
        </div>

        <div className="modal-header">
          <h2>温馨提示</h2>
          <p>检测到您正在使用微信浏览器</p>
        </div>

        <div className="tip-content">
          <div className="tip-card">
            <div className="tip-step">
              <span className="step-num">1</span>
              <p>点击右上角 <strong>「···」</strong> 按钮</p>
            </div>
            <div className="tip-step">
              <span className="step-num">2</span>
              <p>选择 <strong>「在浏览器中打开」</strong></p>
            </div>
            <div className="tip-step">
              <span className="step-num">3</span>
              <p>使用系统浏览器重新下载</p>
            </div>
          </div>

          <div className="tip-note">
            <p>💡 推荐使用 Safari、Chrome 或其他系统浏览器以获得最佳体验</p>
          </div>
        </div>

        <motion.button
          className="action-btn"
          onClick={onClose}
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          我知道了
        </motion.button>
      </motion.div>
    </motion.div>
  );
};

export default WeChatTip;

